"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInstallationPanel = getInstallationPanel;

var _preact = require("preact");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _InputGroupWithSubdomain = _interopRequireDefault(require("../../../ui-components/InputGroupWithSubdomain"));

var _PanelItems = require("../PanelItems");

var ZendeskInstallationPanelBody = function ZendeskInstallationPanelBody(_ref) {
  var isInstalled = _ref.isInstalled,
      isZendeskOAuthEnabled = _ref.isZendeskOAuthEnabled,
      hasLegacyCredentials = _ref.hasLegacyCredentials,
      onConnect = _ref.onConnect,
      _onSave = _ref.onSave,
      _onCancel = _ref.onCancel,
      onSubdomainChangeCallback = _ref.onSubdomainChangeCallback,
      onSubdomainClickCallback = _ref.onSubdomainClickCallback,
      subdomain = _ref.subdomain,
      apiToken = _ref.apiToken,
      agentEmail = _ref.agentEmail,
      onApiTokenChangeCallback = _ref.onApiTokenChangeCallback,
      onApiTokenClickCallback = _ref.onApiTokenClickCallback,
      onAgentEmailChangeCallback = _ref.onAgentEmailChangeCallback,
      onAgentEmailClickCallback = _ref.onAgentEmailClickCallback,
      _onClickManage = _ref.onClickManage,
      _onClickUninstall = _ref.onClickUninstall,
      errorFields = _ref.errorFields,
      isConnecting = _ref.isConnecting,
      isSavingCredentials = _ref.isSavingCredentials;

  var renderButtons = function renderButtons() {
    if (!isInstalled) {
      return isZendeskOAuthEnabled ? (0, _preact.h)(_PanelItems.ActionButtons, {
        onSave: function onSave() {
          return onConnect === null || onConnect === void 0 ? void 0 : onConnect();
        },
        onCancel: function onCancel() {
          return _onCancel();
        },
        primaryButtonVariantType: "brand",
        primaryButtonText: "Connect with Zendesk",
        isLoading: isConnecting
      }) : (0, _preact.h)(_PanelItems.ActionButtons, {
        onSave: function onSave() {
          return _onSave === null || _onSave === void 0 ? void 0 : _onSave();
        },
        onCancel: function onCancel() {
          return _onCancel();
        },
        primaryButtonVariantType: "brand",
        primaryButtonText: "Install",
        isLoading: isSavingCredentials
      });
    }

    if (hasLegacyCredentials && isZendeskOAuthEnabled) {
      return (0, _preact.h)("div", {
        className: "panel-buttons-container"
      }, (0, _preact.h)(_Button.default, {
        size: "medium",
        variant: "brand",
        title: "Re-Authorize with Zendesk",
        onClick: function onClick() {
          return onConnect === null || onConnect === void 0 ? void 0 : onConnect();
        },
        isLoading: isConnecting,
        className: "qa-re-authorize"
      }), (0, _preact.h)(_Button.default, {
        size: "medium",
        variant: "warning",
        title: "Uninstall",
        onClick: function onClick() {
          return _onClickUninstall();
        },
        className: "integration__button_uninstall qa-integration-uninstall"
      }));
    }

    return (0, _preact.h)(_PanelItems.ManageInstallationButtons, {
      onClickManage: function onClickManage() {
        return _onClickManage();
      },
      onClickUninstall: function onClickUninstall() {
        return _onClickUninstall();
      }
    });
  };

  return (0, _preact.h)("div", {
    className: "panel-body-container installation__panel_body"
  }, (0, _preact.h)("div", {
    className: "panel-body-title"
  }, "To install Zendesk, you'll need"), (0, _preact.h)("div", {
    className: "panel-body-description"
  }, (0, _preact.h)("ul", {
    className: "panel-body-description-unordered-list"
  }, (0, _preact.h)("li", null, (0, _preact.h)("span", {
    className: "text--bold panel-body-description-label"
  }, "Admin permissions:"), (0, _preact.h)("span", {
    className: "panel-body-description-label-meta"
  }, ' ', isZendeskOAuthEnabled ? 'Admin permissions required to authorize the Zendesk integration via OAuth.' : 'Admin permissions required to generate an API key from Zendesk.')))), (0, _preact.h)("div", {
    className: "panel-form-input qa-form-subdomain"
  }, (0, _preact.h)(_InputGroupWithSubdomain.default, {
    key: "subdomain",
    title: "Subdomain",
    required: true,
    meta: "This is your registered domain name at Zendesk.com.",
    error: (0, _PanelItems.getErrorMessage)('subdomain', errorFields),
    qaClasses: "qa-subdomain-input",
    value: subdomain,
    disabled: isInstalled,
    onChangeCallback: function onChangeCallback(e) {
      return onSubdomainChangeCallback(e.target.value);
    },
    onClick: function onClick() {
      return onSubdomainClickCallback();
    },
    subdomain: ".zendesk.com"
  })), !isZendeskOAuthEnabled && onAgentEmailChangeCallback && (0, _preact.h)("div", {
    className: "panel-form-input qa-form-agent-email"
  }, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    key: "agentEmail",
    title: "Agent email",
    meta: "Email address you use to login to Zendesk. Please note that this email will be used as the 'submitter' when creating tickets from community posts on behalf of anonymised users.",
    error: (0, _PanelItems.getErrorMessage)('agentEmail', errorFields),
    required: true,
    showIconBeforeErrorMessage: true,
    qaClasses: "qa-agent-email-input",
    value: agentEmail,
    disabled: isInstalled,
    onChangeCallback: function onChangeCallback(e) {
      return onAgentEmailChangeCallback(e.target.value);
    },
    onClick: function onClick() {
      return onAgentEmailClickCallback === null || onAgentEmailClickCallback === void 0 ? void 0 : onAgentEmailClickCallback();
    }
  })), !isZendeskOAuthEnabled && onApiTokenChangeCallback && (0, _preact.h)("div", {
    className: "panel-form-input qa-form-api-token"
  }, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    key: "apiToken",
    title: "API token",
    meta: "You can create an API token in Zendesk via Admin > Channels > API.",
    error: (0, _PanelItems.getErrorMessage)('apiToken', errorFields),
    required: true,
    showIconBeforeErrorMessage: true,
    qaClasses: "qa-api-token-input",
    value: apiToken,
    disabled: isInstalled,
    onChangeCallback: function onChangeCallback(e) {
      return onApiTokenChangeCallback(e.target.value);
    },
    onClick: function onClick() {
      return onApiTokenClickCallback === null || onApiTokenClickCallback === void 0 ? void 0 : onApiTokenClickCallback();
    }
  })), renderButtons());
};

function getInstallationPanel(props) {
  var isInstalled = props.isInstalled,
      isZendeskOAuthEnabled = props.isZendeskOAuthEnabled,
      hasLegacyCredentials = props.hasLegacyCredentials,
      onConnect = props.onConnect,
      onSave = props.onSave,
      _onCancel2 = props.onCancel,
      _onSubdomainChangeCallback = props.onSubdomainChangeCallback,
      _onSubdomainClickCallback = props.onSubdomainClickCallback,
      _onClickManage2 = props.onClickManage,
      _onClickUninstall2 = props.onClickUninstall,
      subdomain = props.subdomain,
      apiToken = props.apiToken,
      agentEmail = props.agentEmail,
      onApiTokenChangeCallback = props.onApiTokenChangeCallback,
      onApiTokenClickCallback = props.onApiTokenClickCallback,
      onAgentEmailChangeCallback = props.onAgentEmailChangeCallback,
      onAgentEmailClickCallback = props.onAgentEmailClickCallback,
      errorFields = props.errorFields,
      hasUnsavedChanges = props.hasUnsavedChanges,
      isConnecting = props.isConnecting,
      isSavingCredentials = props.isSavingCredentials;
  return {
    body: (0, _preact.h)(ZendeskInstallationPanelBody, {
      isInstalled: isInstalled,
      isZendeskOAuthEnabled: isZendeskOAuthEnabled,
      hasLegacyCredentials: hasLegacyCredentials,
      onConnect: onConnect,
      onSave: onSave,
      onCancel: function onCancel() {
        return _onCancel2();
      },
      onSubdomainChangeCallback: function onSubdomainChangeCallback(subdomain) {
        return _onSubdomainChangeCallback(subdomain);
      },
      onSubdomainClickCallback: function onSubdomainClickCallback() {
        return _onSubdomainClickCallback();
      },
      onClickManage: function onClickManage() {
        return _onClickManage2();
      },
      onClickUninstall: function onClickUninstall() {
        return _onClickUninstall2();
      },
      subdomain: subdomain,
      apiToken: apiToken,
      agentEmail: agentEmail,
      onApiTokenChangeCallback: onApiTokenChangeCallback,
      onApiTokenClickCallback: onApiTokenClickCallback,
      onAgentEmailChangeCallback: onAgentEmailChangeCallback,
      onAgentEmailClickCallback: onAgentEmailClickCallback,
      errorFields: errorFields,
      isConnecting: isConnecting,
      isSavingCredentials: isSavingCredentials
    }),
    customClass: 'panel__body_without_header',
    hasUnsavedChanges: hasUnsavedChanges
  };
}